import styled, { css } from 'styled-components';

export const WorkPackageHeaderRowStyled = styled.div`
  ${({ theme }) => css`
    background-image: linear-gradient(275deg, ${theme.colors.bechtel.blue[1000]}, ${theme.colors.bechtel.blue[800]});
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
    display: flex;
    justify-content: space-between;
    position: relative;
  `}
`;
export const WPHeaderOuter = styled.div`
  position: relative;
  z-index: 1;
`;
